"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateAge = void 0;
exports.capitalizeFirstLetter = capitalizeFirstLetter;
exports.convertPercentageToRate = void 0;
exports.customTealiumEvent = customTealiumEvent;
exports.handleDropdownOnSelect = handleDropdownOnSelect;
exports.ifNanReturn0 = ifNanReturn0;
exports.titleCase = exports.parseFloatCurrencyString = exports.parseCurrencyString = exports.numberToString = exports.numberToCurrencyString = void 0;
var _lodash = require("lodash");
/**
 * Removes commas and parses string representation of a number to a true number
 */
var parseCurrencyString = (value, originalValue) => {
  return (0, _lodash.includes)(originalValue, ',') ? (0, _lodash.parseInt)(originalValue.replace(/,/g, '')) : (0, _lodash.parseInt)(originalValue);
};

/**
 * Removes commas and parses string representation of a number to a true number
 */
exports.parseCurrencyString = parseCurrencyString;
var parseFloatCurrencyString = (value, originalValue) => {
  return (0, _lodash.includes)(originalValue, ',') ? parseFloat(originalValue.replace(/,/g, '')) : parseFloat(originalValue);
};

/**
 * Converts a number into a string with commas and puts the '$' symbol at the start of the string.
 * Returns '$0' if undefined
 */
exports.parseFloatCurrencyString = parseFloatCurrencyString;
var numberToCurrencyString = exports.numberToCurrencyString = function numberToCurrencyString(value, fractionDigits) {
  var includeDollarSign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var result;
  if (value == undefined) {
    result = '0';
  } else {
    result = value.toLocaleString('en-US', {
      minimumFractionDigits: fractionDigits || 0,
      maximumFractionDigits: fractionDigits || 0
    });
  }
  if (includeDollarSign) {
    return '$' + result;
  } else {
    return result;
  }
};

/**
 * Converts a number into a string with commas and without '$' symbol at the start of the string.
 * Returns '0' if undefined
 */
var numberToString = (value, fractionDigits) => {
  if (value == undefined) {
    return '0';
  }
  return value.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits || 0,
    maximumFractionDigits: fractionDigits || 0
  });
};

/**
 * Capitalizes the first letter of each word in a string, returns the new string
 */
exports.numberToString = numberToString;
var titleCase = value => {
  if (value == undefined) {
    return '';
  }
  return value.toLowerCase().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
};
exports.titleCase = titleCase;
var calculateAge = (day, month, year) => {
  var dob = new Date(month + '/' + day + '/' + year);
  //calculate month difference from current date in time
  var diff_ms = Date.now() - dob.getTime();
  var age_dt = new Date(diff_ms);
  return Math.abs(age_dt.getUTCFullYear() - 1970);
};
exports.calculateAge = calculateAge;
var convertPercentageToRate = percent => {
  return percent / 100;
};
exports.convertPercentageToRate = convertPercentageToRate;
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/* istanbul ignore next */
/* ignoring because of reliance on global tealium object 'utag', also function does not return */
function handleDropdownOnSelect(value, field, setFieldValue, calcName) {
  setFieldValue(field, value);
  if (field && typeof utag === 'object' && utag.link && value) {
    // eslint-disable-next-line no-undef
    utag.link({
      event_category: calcName ? calcName : 'calculator',
      event_action: 'field_input',
      event_label: field,
      event_property: value
    });
  }
}

/* istanbul ignore next */
/* ignoring because of reliance on global tealium object 'utag', also function does not return */
function customTealiumEvent(event_category, event_action, event_label, event_value) {
  if (event_category && event_action && event_label && typeof utag === 'object' && utag.link) {
    var tealiumObj = {
      event_category: event_category,
      event_action: event_action,
      event_label: event_label
    };
    if (event_value) {
      tealiumObj.event_property = event_value;
    }
    // eslint-disable-next-line no-undef
    utag.link(tealiumObj);
  }
}
function ifNanReturn0(value) {
  return isNaN(value) ? 0 : value;
}